// // frontend/src/hooks/useRecipes.ts
// import { useState, useEffect } from 'react';
// import { Recipe } from '@/types';
// import { recipeService } from '@/services/recipeService';
// import { recommendationService } from '@/services/recommendationService';
// import { useAuth } from '@/contexts/AuthContext';


// export const useRecipes = (category?: string) => {
//     const [recipes, setRecipes] = useState<Recipe[]>([]);
//     const [recommendedRecipes, setRecommendedRecipes] = useState<Recipe[]>([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState<string | null>(null);
//     const { token, isLoggedIn } = useAuth();

//     const fetchRecipes = async () => {
//         try {
//             setLoading(true);
//             setError(null);
//             console.log('Token exists:', !!token);
//             console.log('Is logged in:', isLoggedIn);
//             let fetchedRecipes: Recipe[];

//             if (isLoggedIn && token) {
//                 try {
//                     // Para usuarios loggeados: obtener recetas públicas + privadas del usuario
//                     fetchedRecipes = await recipeService.getUserRecipes(token);
//                 } catch (userRecipesError) {
//                     console.warn('Could not load user recipes, falling back to public:', userRecipesError);
//                     // Fallback: solo recetas públicas si falla
//                     fetchedRecipes = await recipeService.getPublicRecipes();
//                 }

//                 // Cargar recomendaciones personalizadas
//                 try {
//                     const personalizedRecipes = await recommendationService.getPersonalizedRecommendations(token, 12);
//                     setRecommendedRecipes(personalizedRecipes);
//                 } catch (recError) {
//                     console.warn('Could not load recommendations, using fallback:', recError);
//                     // Fallback: usar recetas filtradas por preferencias del usuario
//                     setRecommendedRecipes(fetchedRecipes.slice(0, 12));
//                 }
//             } else {
//                 // Para usuarios no loggeados: solo recetas públicas
//                 fetchedRecipes = await recipeService.getPublicRecipes();
//                 setRecommendedRecipes(fetchedRecipes.slice(0, 12)); // Mostrar algunas como "destacadas"
//             }

//             setRecipes(fetchedRecipes);
//         } catch (err: any) {
//             setError(err.message || 'Error al cargar las recetas');
//             console.error('Error fetching recipes:', err);
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchRecipes();
//     }, [isLoggedIn, token, category]);

//     return {
//         recipes,
//         recommendedRecipes,
//         loading,
//         error,
//         refetch: fetchRecipes
//     };
// };
// frontend/src/hooks/useRecipes.ts
import { useState, useEffect } from 'react';
import { Recipe } from '@/types';
import { recipeService } from '@/services/recipeService';
import { recommendationService } from '@/services/recommendationService';
import { useAuth } from '@/contexts/AuthContext';
import { getCorrectImageUrl } from '@/utils/imageUtils'; // ✅ IMPORTAR

// Función para procesar las imágenes de las recetas
const processRecipeImages = (recipe: Recipe): Recipe => ({
    ...recipe,
    image: getCorrectImageUrl(recipe.image) // ✅ PROCESAR LA IMAGEN
});

const processRecipesImages = (recipes: Recipe[]): Recipe[] =>
    recipes.map(processRecipeImages);

export const useRecipes = (category?: string) => {
    const [recipes, setRecipes] = useState<Recipe[]>([]);
    const [recommendedRecipes, setRecommendedRecipes] = useState<Recipe[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const { token, isLoggedIn } = useAuth();

    const fetchRecipes = async () => {
        try {
            setLoading(true);
            setError(null);
            console.log('🔄 Fetching recipes - User logged in:', isLoggedIn);

            let fetchedRecipes: Recipe[];

            if (isLoggedIn && token) {
                try {
                    // ✅ CORREGIDO: Obtener TODAS las recetas públicas + las del usuario
                    console.log('👤 User is logged in, fetching ALL recipes (public + user)');

                    // Opción 1: Si tienes un endpoint que combine ambas
                    fetchedRecipes = await recipeService.getRecipes(token);

                } catch (allRecipesError) {
                    console.warn('Could not load all recipes, falling back to public:', allRecipesError);
                    // Fallback: solo recetas públicas
                    fetchedRecipes = await recipeService.getPublicRecipes();
                }

                // Cargar recomendaciones personalizadas
                try {
                    const personalizedRecipes = await recommendationService.getPersonalizedRecommendations(token, 12);
                    setRecommendedRecipes(processRecipesImages(personalizedRecipes));
                } catch (recError) {
                    console.warn('Could not load recommendations, using fallback:', recError);
                    setRecommendedRecipes(processRecipesImages(fetchedRecipes.slice(0, 12)));
                }
            } else {
                // Para usuarios no loggeados: solo recetas públicas
                console.log('👤 User not logged in, fetching public recipes only');
                fetchedRecipes = await recipeService.getPublicRecipes();
                setRecommendedRecipes(processRecipesImages(fetchedRecipes.slice(0, 12)));
            }

            console.log('📥 Total recipes loaded:', fetchedRecipes.length);
            console.log('📋 Recipe titles:', fetchedRecipes.map(r => r.title));
            console.log('👥 Recipe owners:', fetchedRecipes.map(r => r.userId || 'no-user'));

            setRecipes(processRecipesImages(fetchedRecipes));

        } catch (err: any) {
            setError(err.message || 'Error al cargar las recetas');
            console.error('Error fetching recipes:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchRecipes();
    }, [isLoggedIn, token, category]);

    return {
        recipes,
        recommendedRecipes,
        loading,
        error,
        refetch: fetchRecipes
    };
};